import { combineReducers } from 'redux';
import {
  createApiReducer,
  chainReducers,
  INITIAL_API_STATE_ITEMS,
} from 'src/api';
import {
  FETCH_AUDITS_START,
  FETCH_AUDITS_SUCCESS,
  FETCH_AUDITS_FAILURE,
  FETCH_AUDIT_START,
  FETCH_AUDIT_SUCCESS,
  FETCH_AUDIT_FAILURE,
  CREATE_AUDIT_START,
  CREATE_AUDIT_SUCCESS,
  CREATE_AUDIT_FAILURE,
  UPDATE_AUDIT_START,
  UPDATE_AUDIT_SUCCESS,
  UPDATE_AUDIT_FAILURE,
  DELETE_AUDIT_START,
  DELETE_AUDIT_SUCCESS,
  DELETE_AUDIT_FAILURE,
  FETCH_AUDIT_HISTORY_START,
  FETCH_AUDIT_HISTORY_SUCCESS,
  FETCH_AUDIT_HISTORY_FAILURE,
} from './actions';

// Data adapter for list of audits
const transformAudits = (payload) => ({
  audits: payload,
});

// Data adapter for single audit
const transformAudit = (payload) => payload;

// Data adapter for audit history
const transformAuditHistory = (payload) => ({
  history: payload,
});

const auditsReducer = createApiReducer(
  [FETCH_AUDITS_START, FETCH_AUDITS_SUCCESS, FETCH_AUDITS_FAILURE],
  transformAudits
);

const auditReducer = createApiReducer(
  [FETCH_AUDIT_START, FETCH_AUDIT_SUCCESS, FETCH_AUDIT_FAILURE],
  transformAudit
);

const createAuditReducer = createApiReducer(
  [CREATE_AUDIT_START, CREATE_AUDIT_SUCCESS, CREATE_AUDIT_FAILURE],
  transformAudit
);

const updateAuditReducer = createApiReducer(
  [UPDATE_AUDIT_START, UPDATE_AUDIT_SUCCESS, UPDATE_AUDIT_FAILURE],
  transformAudit
);

const deleteAuditReducer = createApiReducer(
  [DELETE_AUDIT_START, DELETE_AUDIT_SUCCESS, DELETE_AUDIT_FAILURE],
  () => ({})
);

const auditHistoryReducer = createApiReducer(
  [FETCH_AUDIT_HISTORY_START, FETCH_AUDIT_HISTORY_SUCCESS, FETCH_AUDIT_HISTORY_FAILURE],
  transformAuditHistory
);

export default combineReducers({
  audits: auditsReducer,
  audit: auditReducer,
  createAudit: createAuditReducer,
  updateAudit: updateAuditReducer,
  deleteAudit: deleteAuditReducer,
  auditHistory: auditHistoryReducer,
});